import React, { useEffect, useState } from 'react';
import { completeSignInWithEmailLink } from '../lib/firebase';
import { useNavigate } from 'react-router-dom';
import './AuthVerify.css';

const AuthVerify: React.FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [error, setError] = useState('');

  useEffect(() => {
    const handleEmailVerification = async () => {
      try {
        const result = await completeSignInWithEmailLink();
        if (result) {
          setStatus('success');
          setTimeout(() => {
            navigate('/');
          }, 2000);
        } else {
          setStatus('error');
          setError('Link de verificação inválido ou expirado.');
        }
      } catch (error: any) {
        setStatus('error');
        setError(error.message || 'Erro ao verificar email.');
      }
    };

    handleEmailVerification();
  }, [navigate]);

  return (
    <div className="auth-verify-page">
      <div className="auth-verify-container">
        {status === 'verifying' && (
          <>
            <div className="loading-spinner"></div>
            <h2>Verificando seu email...</h2>
            <p>Aguarde enquanto confirmamos seu login.</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h2>Login realizado com sucesso!</h2>
            <p>Redirecionando você para a página inicial...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="error-icon">✗</div>
            <h2>Erro na verificação</h2>
            <p>{error}</p>
            <button 
              className="back-btn"
              onClick={() => navigate('/')}
            >
              Voltar ao início
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthVerify;